import { useMediaQuery } from 'react-responsive';

import { mobileScreenMaxWidth } from '@forms-exp/constants';

export const useMobile = () => {
  const isMobileScreen = useMediaQuery({ query: `(max-width: ${mobileScreenMaxWidth})` });
  return { isMobileScreen };
};
